import React, { useState } from "react";
import axios from "axios";
import swal from "sweetalert";

const styles = {
    body: {
        fontFamily: "Arial, sans-serif",
        background: "#f3f5f7",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "30px",
    },

    container: {
        width: "500px",
        background: "#fff",
        padding: "30px",
        borderRadius: "12px",
        boxShadow: "0 10px 25px rgba(0,0,0,.08)",
    },

    logo: {
        textAlign: "center",
        marginBottom: "15px",
    },

    logoImg: {
        maxWidth: "180px",
    },

    title: {
        textAlign: "center",
        fontSize: "28px",
        fontWeight: "500",
        marginBottom: "10px",
    },

    subtitle: {
        textAlign: "center",
        fontSize: "14px",
        color: "#666",
        marginBottom: "20px",
    },

    note: {
        background: "#eef4ff",
        border: "1px solid #c7d7ff",
        padding: "15px",
        borderRadius: "6px",
        fontSize: "13px",
        color: "#2b4db8",
        marginBottom: "20px",
    },

    group: {
        marginBottom: "15px",
    },

    input: {
        width: "100%",
        padding: "10px",
        border: "1px solid #ccc",
        borderRadius: "6px",
        fontSize: "14px",
    },

    textarea: {
        width: "100%",
        padding: "10px",
        border: "1px solid #ccc",
        borderRadius: "6px",
        fontSize: "14px",
        minHeight: "100px",
    },

    button: {
        width: "100%",
        padding: "12px",
        background: "#e62222",
        color: "#fff",
        border: "none",
        borderRadius: "6px",
        fontSize: "16px",
        cursor: "pointer",
        marginTop: "10px",
    },
};

const DeleteAccount = () => {
    const [form, setForm] = useState({
        first_name: "",
        email: "",
        phone: "",
        delete_comment: "",
    });

    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!form.first_name) {
            swal("Error", "Please enter full name", "error");
            return;
        }

        if (!form.email) {
            swal("Error", "Please enter email", "error");
            return;
        }

        if (!form.phone) {
            swal("Error", "Please enter phone number", "error");
            return;
        }

        try {
            setLoading(true);

            const res = await axios.post("/api/delete-account", form);

            if (res.data.success) {
                swal(
                    "Success",
                    res.data.message || "Delete request submitted successfully",
                    "success"
                );

                setForm({
                    first_name: "",
                    email: "",
                    phone: "",
                    delete_comment: "",
                });
            } else {
                swal(
                    "Error",
                    res.data.message || "Unable to submit request",
                    "error"
                );
            }
        } catch (err) {
            swal(
                "Error",
                err?.response?.data?.message || "Something went wrong",
                "error"
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={styles.body}>
            <div style={styles.container}>

                <div style={styles.logo}>
                    <img
                        src={"/frontend/images/logo.png"}
                        alt="logo"
                        style={styles.logoImg}
                    />
                </div>

                <div style={styles.title}>Delete User</div>

                <div style={styles.subtitle}>
                    This form allows you to request the permanent deletion of a user account.
                </div>

                <div style={styles.note}>
                    <strong>Note:</strong> Deleting a user will permanently remove their access.
                </div>

                <form onSubmit={handleSubmit}>
                    <div style={styles.group}>
                        <label>Full Name *</label>
                        <input
                            type="text"
                            name="first_name"
                            value={form.first_name}
                            onChange={handleChange}
                            style={styles.input}
                        />
                    </div>

                    <div style={styles.group}>
                        <label>Email *</label>
                        <input
                            type="email"
                            name="email"
                            value={form.email}
                            onChange={handleChange}
                            style={styles.input}
                        />
                    </div>

                    <div style={styles.group}>
                        <label>Phone *</label>
                        <input
                            type="text"
                            name="phone"
                            value={form.phone}
                            onChange={handleChange}
                            style={styles.input}
                        />
                    </div>

                    <div style={styles.group}>
                        <label>Additional Message</label>
                        <textarea
                            name="delete_comment"
                            value={form.delete_comment}
                            onChange={handleChange}
                            style={styles.textarea}
                        />
                    </div>

                    <button type="submit" style={styles.button}>
                        Delete Account
                    </button>
                </form>

            </div>
        </div>
    );
};

export default DeleteAccount;